import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { SubscriptionType } from './subscription-type.model';
import { SubscriptionTypePopupService } from './subscription-type-popup.service';
import { SubscriptionTypeService } from './subscription-type.service';
import { School, SchoolService } from '../school';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal } from '../../shared/index';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-subscription-type-dialog',
    templateUrl: './subscription-type-dialog.component.html'
})
export class SubscriptionTypeDialogComponent extends AbstractDialogComponent implements OnInit {

    subscriptionType: SubscriptionType;
    authorities: any[];
    isSaving: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private subscriptionTypeService: SubscriptionTypeService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['subscriptionType', 'recurrence']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.loadSchools();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.subscriptionType.id !== undefined) {
            this.subscriptionTypeService.update(this.subscriptionType)
                .delay(8000)
                .subscribe((res: SubscriptionType) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.subscriptionTypeService.create(this.subscriptionType)
                .subscribe((res: SubscriptionType) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    showLoader(): boolean {
        return this.isSaving && this.subscriptionType.id !== undefined;
    }

    private onSaveSuccess(result: SubscriptionType) {
        this.eventManager.broadcast({ name: 'subscriptionTypeListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-subscription-type-popup',
    template: ''
})
export class SubscriptionTypePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private subscriptionTypePopupService: SubscriptionTypePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.subscriptionTypePopupService
                    .open(SubscriptionTypeDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.subscriptionTypePopupService
                    .open(SubscriptionTypeDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/subscription-type/subscription-type-dialog.component.ts